import React, { useEffect } from 'react';
import "./glitchLines.scss";
import { gsap } from 'gsap';
import { useAnimationContext } from '../../AnimationContext';

const GlitchLines = ({ parentRef }) => {
    const { isPreloaderComplete } = useAnimationContext();

    useEffect(() => {
        if (isPreloaderComplete) {
            // Delay the start of the animation by 5 seconds
            const animationDelay = setTimeout(() => {
                if (!parentRef.current) return;
        
                const lines = parentRef.current.querySelectorAll('line');
                const numOfLines = lines.length;
        
                // Shuffle the lines randomly
                const shuffledLines = Array.from(lines).sort(() => Math.random() - 0.5);
        
                shuffledLines.forEach((line, index) => {
                    // Calculate total animation time before repeating
                    const totalAnimationTime = 4 * numOfLines;
        
                    // Create a timeline for each line with a staggered start
                    gsap.timeline({
                        delay: index * 5,
                        repeat: -1,
                        repeatDelay: totalAnimationTime, 
                    })
                    .to(line, { 
                        onStart: () => line.classList.add('shakeLine'), 
                        onComplete: () => line.classList.remove('shakeLine'), 
                        duration: 2 
                    })
                    
                });
            }, 5000); // = 5 seconds
        
            // Cleanup function to clear the timeout if the component unmounts
            return () => clearTimeout(animationDelay);
        }
    }, [isPreloaderComplete, parentRef]); // Add parentRef to the dependency array to re-run the effect if the ref changes

    return (
        <></>
    );
};

export default GlitchLines;